import { Link } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";

function AppStoreBadge() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 120 40"
      className="store-badge-svg"
      role="img"
      aria-hidden="true"
    >
      <rect width="120" height="40" rx="5.5" fill="#000" />
      <path
        fill="#fff"
        d="M24.55 20.15a3.75 3.75 0 0 1 1.8-3.16 3.88 3.88 0 0 0-3.06-1.65c-1.3-.13-2.55.78-3.21.78-.66 0-1.68-.76-2.77-.74a4.07 4.07 0 0 0-3.43 2.09c-1.48 2.55-.38 6.32 1.05 8.39.7 1.01 1.52 2.14 2.61 2.1 1.05-.04 1.45-.68 2.72-.68 1.26 0 1.63.68 2.75.65 1.14-.02 1.85-1.02 2.54-2.04a8.43 8.43 0 0 0 1.16-2.36 3.63 3.63 0 0 1-2.16-3.38Zm-2.01-5.92a3.71 3.71 0 0 0 .85-2.65 3.78 3.78 0 0 0-2.48 1.28 3.55 3.55 0 0 0-.88 2.56 3.14 3.14 0 0 0 2.51-1.19Z"
      />
      <text
        x="34.5"
        y="15.2"
        fill="#fff"
        fontFamily="-apple-system, BlinkMacSystemFont, Arial, sans-serif"
        fontSize="6.2"
      >
        Download on the
      </text>
      <text
        x="34.5"
        y="27.8"
        fill="#fff"
        fontFamily="-apple-system, BlinkMacSystemFont, Arial, sans-serif"
        fontSize="11.5"
        fontWeight="600"
      >
        App Store
      </text>
    </svg>
  );
}

function GooglePlayBadge() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 135 40"
      className="store-badge-svg"
      role="img"
      aria-hidden="true"
    >
      <rect width="135" height="40" rx="5.5" fill="#000" />
      <g transform="translate(9.5, 7.5) scale(0.95)">
        <path fill="#EA4335" d="M1.5 1.1 14.8 13.1 1.5 25.1V1.1Z" />
        <path fill="#FBBC04" d="m1.5 25.1 4.6-2.5 8.7-9.5L1.5 25.1Z" />
        <path fill="#4285F4" d="M22.2 16.7 18.3 14.4l-3.5-1.6L1.5 25.1l20.7-8.4Z" />
        <path fill="#34A853" d="M1.5 1.1 22.2 10.1 18.3 12.4 1.5 1.1Z" />
        <path
          fill="#FFF"
          opacity="0.1"
          d="M14.8 13.1 18.3 14.4 22.2 16.7 18.3 12.4 14.8 13.1Z"
        />
      </g>
      <text
        x="37"
        y="15.2"
        fill="#fff"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize="6"
        letterSpacing="0.6"
      >
        GET IT ON
      </text>
      <text
        x="37"
        y="27.8"
        fill="#fff"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize="11.5"
        fontWeight="600"
      >
        Google Play
      </text>
    </svg>
  );
}

function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col footer-col--brand">
            <Link to="/" className="brand brand--footer">
              <img
                src={`${process.env.PUBLIC_URL}/logo.png`}
                alt="The Way 5:23"
                className="brand-logo brand-logo--footer"
              />
            </Link>
            <div className="footer-contact">
              
            </div>
          </div>

          <nav className="footer-col footer-col--nav" aria-label="Footer">
            <p className="footer-heading">Explore</p>
            <div className="footer-nav">
              <a href="/#features">Features</a>
              <a href="/#features">Manna</a>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/contact">Contact Us</Link>
            </div>
          </nav>

          <div className="footer-col footer-col--apps">
            <p className="footer-heading">Get the App</p>
            <div className="footer-store-badges">
              <a
                href="#app-store"
                className="store-badge"
                aria-label="Download on the App Store"
              >
                <AppStoreBadge />
              </a>
              <a
                href="#google-play"
                className="store-badge"
                aria-label="Get it on Google Play"
              >
                <GooglePlayBadge />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">
            Copyright © 2026 theway523.com. All rights reserved.
          </p>
        </div>
      </div>

      <ScrollToTop />
    </footer>
  );
}

export default SiteFooter;
